/** Copyright (c) 2019 T. Rowe Price. All rights reserved. */

import './TrustedContactsModalInformation.scss';

import { forEach, pick } from 'lodash';
import { object, string } from 'prop-types';
import React, { Fragment } from 'react';
import { connect } from 'react-redux';

import ProfileLabeledInput from 'components/layouts/Preferences/ProfileLabeledInput';
import { USPhoneNumberRow } from 'components/layouts/Preferences/UpdateContactInformation/EmailPhone/PhoneNumberRow';
import Store from 'state/Store';
import {
  handleMultipleValidations,
  isFieldRequired,
  isValidName,
  isValidRequiredUsPhoneNumber,
  trustedContactAddressValidation
} from 'services/Validation';
import { touchedField } from 'state/validation/ValidationActions';
import WithUserPermissions from 'components/shared/WithUserPermissions/WithUserPermissions';
import TextInput from 'components/shared/Text/TextInput';

const FirstNameWithPermissions = WithUserPermissions(TextInput);
const LastNameWithPermissions = WithUserPermissions(TextInput);

const DEFAULT_PHONE_TYPE_FIELD = 'daytimePhone';
const getPhoneTypeField = (phoneNumbers) => {
  const numberTypes = pick(phoneNumbers, [
    'daytimePhone',
    'eveningPhone',
    'mobilePhone'
  ]);
  let phoneTypeField = DEFAULT_PHONE_TYPE_FIELD;
  forEach(numberTypes, (val, key) => {
    if (val !== '') {
      phoneTypeField = key;
    }
  });

  return phoneTypeField;
};
const TrustedContactsModalInformation = ({
  firstName,
  invalidFields,
  lastName,
  onChange,
  phoneNumbers,
  touchedFields
}) => {
  const phoneTypeField = getPhoneTypeField(phoneNumbers);

  const onFieldChange = (field) => (event) => {
    const value = event.target.value;
    onChange(field)(value);
  };

  const onFieldBlur = (field) => () => Store.dispatch(touchedField(field));

  const nameValidator = (field) => ({
    field,
    shouldValidate: touchedFields[field] === true,
    validator: (value) =>
      handleMultipleValidations(value, [isFieldRequired, isValidName]),
    value: field === 'firstName' ? firstName : lastName
  });

  const onPhoneNumberChange = (field, value) =>
    onChange('phoneNumbers', field)(value);

  return (
    <Fragment>
      <ProfileLabeledInput
        errorMessage={invalidFields['firstName']}
        label="First Name"
        validators={[nameValidator('firstName')]}>
        <FirstNameWithPermissions
          className="first-name-input"
          value={firstName}
          onBlur={onFieldBlur('firstName')}
          onChange={onFieldChange('firstName')}
          shouldMask
        />
      </ProfileLabeledInput>
      <ProfileLabeledInput
        errorMessage={invalidFields['lastName']}
        label="Last Name"
        validators={[nameValidator('lastName')]}>
        <LastNameWithPermissions
          className="last-name-input"
          value={lastName}
          onBlur={onFieldBlur('lastName')}
          onChange={onFieldChange('lastName')}
          shouldMask
        />
      </ProfileLabeledInput>
      <USPhoneNumberRow field={phoneTypeField}
                        hasExt={true}
                        invalidFields={invalidFields}
                        label={'Phone'}
                        onChange={onPhoneNumberChange}
                        phoneNumbers={phoneNumbers}
                        touchedFields={touchedFields}
                        validator={isValidRequiredUsPhoneNumber}
                        validations={trustedContactAddressValidation}/>
    </Fragment>
  );
};

TrustedContactsModalInformation.propTypes = {
  firstName: string,
  invalidFields: object.isRequired,
  lastName: string,
  phoneNumbers: object,
  touchedFields: object.isRequired
};

const mapStateToProps = (state) => ({
  invalidFields: state.invalidFields,
  touchedFields: state.touchedFields
});

export default connect(mapStateToProps)(TrustedContactsModalInformation);
